import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import VueJwtDecode from 'vue-jwt-decode'

import { api } from '../services/config'
import { mixin } from '@/mixins/helper'
import { permissionData } from './general_permission'

import modalStore from './modules/modal'
import searchStore from './modules/search'
import level1 from './modules/level1'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    loading: false,
    alert: false,
    alertMsg: '',
    is_login: false,
    currentUser: null,
    currentEmail: null,
    userid: null,
    permissions: null,
    kode: null,
    token: null,
    role_id: null,

    k3lCategories: [],
    kplhCategories: [],

    overlayOpacity: 0,
    slides: [],
    currentIndexing: [],
  },

  mutations: {
    setLoading(state, status) {
      console.log('set loading', status)
      state.loading = status
    },
    setData(state, payload) {
      state[payload.name] = payload.value
    },
    SET_NOTIF(state, msg) {
      state.alert = true
      state.alertMsg = msg

      setTimeout(() => {
        state.alert = false
        state.alertMsg = ''
      }, 2000)
    },
    SET_NOTIF_OPEN(state, msg) {
      state.alert = true
      state.alertMsg = msg
    },
    SET_NOTIF_CLOSE(state) {
      state.alert = false
      state.alertMsg = ''
    },
    AUTO_LOGIN(state) {
      const isToken = localStorage.getItem('token')
      const isPermissions = JSON.parse(localStorage.getItem('permissions'))
      const isKode = JSON.parse(localStorage.getItem('kode'))
      if (isToken && isPermissions) {
        const dec = VueJwtDecode.decode(isToken)
        state.is_login = true
        state.currentUser = dec.name
        state.currentEmail = dec.email
        state.userid = dec.id
        state.role_id = isPermissions[0].role_id
        state.permissions = isPermissions.reduce(
          (obj, item) => (
            (obj[item.permission_id] = {
              allow: item.allow == 1 ? true : false,
              modul: mixin.methods.$get(item, 'permission.modul'),
              function: mixin.methods.$get(item, 'permission.function'),
            }),
            obj
          ),
          {}
        )
        state.token = isToken
      } else {
        state.permissions = permissionData.reduce(
          (obj, item) => (
            (obj[item.permission_id] = {
              allow: item.allow == 1 ? true : false,
              modul: mixin.methods.$get(item, 'permission.modul'),
              function: mixin.methods.$get(item, 'permission.function'),
            }),
            obj
          ),
          {}
        )
      }

      if (isKode && isKode.length > 0) {
        state.kode = isKode
      }
      console.log('user id: ', state.userid)
      console.log('role id: ', state.role_id)
      console.log('company code: ', state.kode)
    },
    // Currently only available for SIPM
    UNSET_CURRENT_USER(state) {
      state.is_login = false
      state.currentUser = null
      state.currentEmail = null
      state.userid = null
      state.role_id = null
      localStorage.removeItem('token')
      localStorage.removeItem('permissions')
      localStorage.removeItem('kode')
      state.permissions = permissionData.reduce(
        (obj, item) => (
          (obj[item.permission_id] = {
            allow: item.allow == 1 ? true : false,
            modul: mixin.methods.$get(item, 'permission.modul'),
            function: mixin.methods.$get(item, 'permission.function'),
          }),
          obj
        ),
        {}
      )
      state.token = null
    },
    SET_PERMISSIONS(state, permissions) {
      localStorage.setItem('permissions', JSON.stringify(permissions))
      state.permissions = permissions.reduce(
        (obj, item) => (
          (obj[item.permission_id] = {
            allow: item.allow == 1 ? true : false,
            modul: mixin.methods.$get(item, 'permission.modul'),
            function: mixin.methods.$get(item, 'permission.function'),
          }),
          obj
        ),
        {}
      )
    },
    SET_TOKEN(state, token) {
      state.token = token
      localStorage.setItem('token', token)
      const dec = VueJwtDecode.decode(token)
      state.currentEmail = dec.email
      state.currentUser = dec.name
      state.userid = dec.id
    },
    SET_KODE(state, kode) {
      localStorage.setItem('kode', JSON.stringify(kode))
      state.kode = kode
    },
    DONT_HAVE_PERMISSIONS(state, msg) {
      state.showModalNotif = true
      state.notifText = `Maaf, anda tidak memiliki akses`

      setTimeout(() => {
        state.showModalNotif = false
        state.notifText = ''
      }, 2000)
    },
    ADD_NEW_SLIDE(state, payload) {
      state.slides.unshift(payload)
      state.currentIndexing.unshift(payload.indexing)

      console.log('slides: ', state.slides, state.currentIndexing)
    },
    DELETE_SLIDE(state, payload) {
      state.slides.splice(payload, 1)
      state.currentIndexing.splice(payload, 1)

      console.log('slides state: ', state.slides, state.currentIndexing)
    },
    UPDATE_INDEXING(state) {
      const slides = state.slides
      let indexing = state.indexing

      indexing = slides.map(item => {
        return item.indexing
      })

      state.currentIndexing = indexing
    },
  },
  actions: {
    async login({ dispatch, commit }, params) {
      await commit('SET_CURRENT_USER', params)
      await dispatch('checkLogin')
    },
    logout({ commit }) {
      commit('UNSET_CURRENT_USER')
    },
    async getSlides({ state }) {
      console.log('run get slide')
      try {
        const { data } = await axios({
          method: 'GET',
          url: `${api}/api/v1/carousel?page=1&limit=100`,
        })

        if (data && data.status == 'success') {
          const slides = data.data
          const newSlides = slides.map(item => {
            return {
              id: item.id,
              alt: `Image ${item.id}`,
              indexing: item.indexing,
              image: `${api}/file/${item.path}`,
            }
          })
          const forIndexing = newSlides.map(item => {
            return item.indexing
          })

          state.slides = newSlides
          state.currentIndexing = forIndexing

          console.log('slides from home: ', newSlides, forIndexing)
        }
      } catch (error) {}
    },
    async updateIndexing({ state }) {
      state.loading = true
      try {
        const { data } = await axios({
          method: 'POST',
          url: `${api}/api/v1/carousel/update-indexing`,
          data: {
            indexing: JSON.stringify(state.currentIndexing),
          },
        })

        if (data && data.status == 'success') {
          state.loading = false
        }
      } catch (error) {
        state.loading = false
        alert('error: ', error.response.data.message)
      }
    },
  },
  modules: {
    modalStore,
    searchStore,
    level1,
  },
})
